<template>
  <div class="game__stream">
    <div class="game__stream__player">
      <iframe :src="getUrlVimeoPlayer()" frameborder="0" allow="autoplay;"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: String
  },
  methods: {
    getUrlVimeoPlayer() {
      return `${process.env.VUE_APP_URL_VIMEO}${this.id}?playsinline=1`
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.game__stream {
  margin: $margin-base;

  @media (min-width: $break-md) {
    max-width: 480px;
    width: 100%;
    position: absolute;
    right: 0;
    height: 270px;
    display: flex;
    justify-content: flex-end;
  }

  @media (min-width: $break-lg) {
    height: 364px;
    max-width: 640px;
  }

  &__player {
    border-radius: $margin-milli;
    width: 160px;
    left: 0;
    height: 90px;
    border: 2px solid $lightblue;
    position: relative;
    top: -24px;
    z-index: 2;
    box-shadow: $shadow;
    background: $lightblue;

    @media (min-height: 500px) {
      padding: 56.25% 0 0 0;
      width: 100%;
      height: auto;
      left: auto;
      bottom: auto;
      top: auto;
    }

    iframe {
      overflow: hidden;
      border-radius: $margin-milli;
      position:absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
      background: $lightblue;
    }
  }
}
</style>